import React from "react";

import { MediumHeader } from "@narvar/nth-bit-header";
import { LineItemGroupHeaderProps } from "./types";
import useStyles from "./LineItemGroupHeaderStyles";

const LineItemGroupHeader: React.FC<LineItemGroupHeaderProps> = ({ title }) => {
  const classes = useStyles();
  if (!title) return null;

  return (
    <div className={classes.root}>
      {React.isValidElement(title) ? (
        title
      ) : (
        <MediumHeader>{title}</MediumHeader>
      )}
    </div>
  );
};

export default LineItemGroupHeader;
